export default "__VITE_ASSET__yLw8scIB__"